var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6285 22.009C14.4609 19.5163 19.5 14.4235 19.5 9.75C19.5 7.16414 18.4728 4.68419 16.6443 2.85571C14.8158 1.02723 12.3359 0 9.75 0C7.16414 0 4.68419 1.02723 2.85571 2.85571C1.02723 4.68419 3.85323e-08 7.16414 0 9.75C0 14.4235 5.0375 19.5163 7.8715 22.009C8.38843 22.4704 9.0571 22.7254 9.75 22.7254C10.4429 22.7254 11.1116 22.4704 11.6285 22.009ZM6.5 9.75C6.5 8.88805 6.84241 8.0614 7.4519 7.4519C8.0614 6.84241 8.88805 6.5 9.75 6.5C10.612 6.5 11.4386 6.84241 12.0481 7.4519C12.6576 8.0614 13 8.88805 13 9.75C13 10.612 12.6576 11.4386 12.0481 12.0481C11.4386 12.6576 10.612 13 9.75 13C8.88805 13 8.0614 12.6576 7.4519 12.0481C6.84241 11.4386 6.5 10.612 6.5 9.75Z",
    fill: "#FF4E3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinRed);
export default __webpack_public_path__ + "static/media/pin-red.ddbcdfbb0d0836c57390d497d0bbfb55.svg";
export { ForwardRef as ReactComponent };